const INITIAL_STATE = {
  sections: [
    {
      title: "hats",
      imageUrl:
        "https://cdn.shopify.com/s/files/1/0759/5877/products/Trucker_Deuce_BlackBlack_WEB_04_5000x.jpg?v=1595287031",
      id: 1,
      linkUrl: "shop/hats",
    },
    {
      title: "jackets",
      imageUrl:
        "https://cdn05.wildcraft.com/web-images/preview/styles/1K0AKW74TZE/1567676717360/1.JPG",
      id: 2,
      linkUrl: "shop/jackets",
    },
    {
      title: "sneakers",
      imageUrl:
        "https://cdn.shopify.com/s/files/1/0074/0219/2951/products/NIKEZI-Performance-Official-Original-Men-Outdoor-Running-Exercise-Sport-Shoes-Gym-Shark-Sneakers-Volcano-Yeezys-Air.jpg_640x640_1d01c9de-7d71-47f4-8c93-781caac84556_1024x1024@2x.jpg?v=1579526735",
      id: 3,
      linkUrl: "shop/sneakers",
    },
    {
      title: "womens",
      imageUrl:
        "https://columbiasportswear.co.in/pub/media/catalog/product/cache/2afbbbd2e8744bd60e69dd9224df0cef/w/k/wk1499-671_1.jpg",
      size: "large",
      id: 4,
      linkUrl: "shop/womens",
    },
    {
      title: "mens",
      imageUrl:
        "https://nypost.com/wp-content/uploads/sites/2/2018/06/men-shopping-masculine.jpg?quality=80&strip=all",
      size: "large",
      id: 5,
      linkUrl: "shop/mens",
    },
  ],
};

const directoryReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default directoryReducer;
